// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/iconfont.woff2?t=1664248198543", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/iconfont.woff?t=1664248198543", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/iconfont.ttf?t=1664248198543", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "iconfont"; /* Project id 3154166 */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
  url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');

}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-xiaoxi:before {
  content: "\\e74c";
}

.icon-exclamation-circle:before {
  content: "\\e95d";
}

.icon-success:before {
  content: "\\e6e7";
}

.icon-rotate-loading:before {
  content: "\\e63b";
}

.icon-local:before {
  content: "\\e605";
}

.icon-scan:before {
  content: "\\e8b5";
}

.icon-express:before {
  content: "\\e604";
}

.icon-call-forward:before {
  content: "\\e86c";
}

.icon-reopen:before {
  content: "\\e69c";
}

.icon-complete:before {
  content: "\\e650";
}

.icon-new-message:before {
  content: "\\e667";
}

.icon-new:before {
  content: "\\e67f";
}

.icon-processing:before {
  content: "\\e62c";
}

.icon-replied:before {
  content: "\\e611";
}

.icon-overtime:before {
  content: "\\e61f";
}

.icon-xiala:before {
  content: "\\e6b9";
}

.icon-photo:before {
  content: "\\e8d1";
}

.icon-video-full:before {
  content: "\\eca5";
}

.icon-shexiangtou_guanbi:before {
  content: "\\eca6";
}

.icon-video:before {
  content: "\\e63a";
}

.icon-hangup:before {
  content: "\\e616";
}

.icon-audio:before {
  content: "\\e62b";
}

.icon-dianhua:before {
  content: "\\e6bd";
}

.icon-gantanhao:before {
  content: "\\e603";
}

.icon-tips:before {
  content: "\\e7ac";
}

.icon-del-full:before {
  content: "\\e636";
}

.icon-msg:before {
  content: "\\e619";
}

.icon-collapsed:before {
  content: "\\e670";
}

.icon-call-full:before {
  content: "\\e7c5";
}

.icon-ticket-full:before {
  content: "\\e621";
}

.icon-business-full:before {
  content: "\\e761";
}

.icon-set-full:before {
  content: "\\e608";
}

.icon-chart-full:before {
  content: "\\e7f8";
}

.icon-task-full:before {
  content: "\\e648";
}

.icon-workbench:before {
  content: "\\e60f";
}

.icon-filter-full:before {
  content: "\\e602";
}

.icon-filter:before {
  content: "\\e639";
}

.icon-back:before {
  content: "\\e677";
}

.icon-upload-outlined:before {
  content: "\\e694";
}

.icon-reload:before {
  content: "\\e788";
}

.icon-delete-outlined:before {
  content: "\\e607";
}

.icon-plus-circle:before {
  content: "\\e76b";
}

.icon-empty:before {
  content: "\\e601";
}

.icon-null:before {
  content: "\\e60d";
}

.icon-loading:before {
  content: "\\e6cd";
}

.icon-message:before {
  content: "\\e610";
}

.icon-close-outlined:before {
  content: "\\e6e8";
}

.icon-check-outlined:before {
  content: "\\e645";
}

.icon-sync:before {
  content: "\\e786";
}

.icon-minus-circle:before {
  content: "\\e64b";
}

.icon-close-circle:before {
  content: "\\e653";
}

.icon-check:before {
  content: "\\e600";
}

.icon-checked:before {
  content: "\\e646";
}

.icon-search:before {
  content: "\\e699";
}

.icon-download:before {
  content: "\\e60b";
}

.icon-plus:before {
  content: "\\e67b";
}

.icon-edit-fill:before {
  content: "\\e86d";
}

.icon-edit:before {
  content: "\\e60e";
}

.icon-close:before {
  content: "\\e747";
}

.icon-picture:before {
  content: "\\e743";
}

.icon-folder-outlined:before {
  content: "\\e89e";
}

.icon-video-fill:before {
  content: "\\e865";
}

.icon-flag:before {
  content: "\\e72f";
}

.icon-set:before {
  content: "\\eb8d";
}

.icon-logout:before {
  content: "\\e6bc";
}
`, "",{"version":3,"sources":["webpack://./client/iconfont.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB,EAAE,uBAAuB;EAChD;;4DAE8D;;AAEhE;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\r\n  font-family: \"iconfont\"; /* Project id 3154166 */\r\n  src: url('./fonts/iconfont.woff2?t=1664248198543') format('woff2'),\r\n  url('./fonts/iconfont.woff?t=1664248198543') format('woff'),\r\n  url('./fonts/iconfont.ttf?t=1664248198543') format('truetype');\r\n\r\n}\r\n\r\n.iconfont {\r\n  font-family: \"iconfont\" !important;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.icon-xiaoxi:before {\r\n  content: \"\\e74c\";\r\n}\r\n\r\n.icon-exclamation-circle:before {\r\n  content: \"\\e95d\";\r\n}\r\n\r\n.icon-success:before {\r\n  content: \"\\e6e7\";\r\n}\r\n\r\n.icon-rotate-loading:before {\r\n  content: \"\\e63b\";\r\n}\r\n\r\n.icon-local:before {\r\n  content: \"\\e605\";\r\n}\r\n\r\n.icon-scan:before {\r\n  content: \"\\e8b5\";\r\n}\r\n\r\n.icon-express:before {\r\n  content: \"\\e604\";\r\n}\r\n\r\n.icon-call-forward:before {\r\n  content: \"\\e86c\";\r\n}\r\n\r\n.icon-reopen:before {\r\n  content: \"\\e69c\";\r\n}\r\n\r\n.icon-complete:before {\r\n  content: \"\\e650\";\r\n}\r\n\r\n.icon-new-message:before {\r\n  content: \"\\e667\";\r\n}\r\n\r\n.icon-new:before {\r\n  content: \"\\e67f\";\r\n}\r\n\r\n.icon-processing:before {\r\n  content: \"\\e62c\";\r\n}\r\n\r\n.icon-replied:before {\r\n  content: \"\\e611\";\r\n}\r\n\r\n.icon-overtime:before {\r\n  content: \"\\e61f\";\r\n}\r\n\r\n.icon-xiala:before {\r\n  content: \"\\e6b9\";\r\n}\r\n\r\n.icon-photo:before {\r\n  content: \"\\e8d1\";\r\n}\r\n\r\n.icon-video-full:before {\r\n  content: \"\\eca5\";\r\n}\r\n\r\n.icon-shexiangtou_guanbi:before {\r\n  content: \"\\eca6\";\r\n}\r\n\r\n.icon-video:before {\r\n  content: \"\\e63a\";\r\n}\r\n\r\n.icon-hangup:before {\r\n  content: \"\\e616\";\r\n}\r\n\r\n.icon-audio:before {\r\n  content: \"\\e62b\";\r\n}\r\n\r\n.icon-dianhua:before {\r\n  content: \"\\e6bd\";\r\n}\r\n\r\n.icon-gantanhao:before {\r\n  content: \"\\e603\";\r\n}\r\n\r\n.icon-tips:before {\r\n  content: \"\\e7ac\";\r\n}\r\n\r\n.icon-del-full:before {\r\n  content: \"\\e636\";\r\n}\r\n\r\n.icon-msg:before {\r\n  content: \"\\e619\";\r\n}\r\n\r\n.icon-collapsed:before {\r\n  content: \"\\e670\";\r\n}\r\n\r\n.icon-call-full:before {\r\n  content: \"\\e7c5\";\r\n}\r\n\r\n.icon-ticket-full:before {\r\n  content: \"\\e621\";\r\n}\r\n\r\n.icon-business-full:before {\r\n  content: \"\\e761\";\r\n}\r\n\r\n.icon-set-full:before {\r\n  content: \"\\e608\";\r\n}\r\n\r\n.icon-chart-full:before {\r\n  content: \"\\e7f8\";\r\n}\r\n\r\n.icon-task-full:before {\r\n  content: \"\\e648\";\r\n}\r\n\r\n.icon-workbench:before {\r\n  content: \"\\e60f\";\r\n}\r\n\r\n.icon-filter-full:before {\r\n  content: \"\\e602\";\r\n}\r\n\r\n.icon-filter:before {\r\n  content: \"\\e639\";\r\n}\r\n\r\n.icon-back:before {\r\n  content: \"\\e677\";\r\n}\r\n\r\n.icon-upload-outlined:before {\r\n  content: \"\\e694\";\r\n}\r\n\r\n.icon-reload:before {\r\n  content: \"\\e788\";\r\n}\r\n\r\n.icon-delete-outlined:before {\r\n  content: \"\\e607\";\r\n}\r\n\r\n.icon-plus-circle:before {\r\n  content: \"\\e76b\";\r\n}\r\n\r\n.icon-empty:before {\r\n  content: \"\\e601\";\r\n}\r\n\r\n.icon-null:before {\r\n  content: \"\\e60d\";\r\n}\r\n\r\n.icon-loading:before {\r\n  content: \"\\e6cd\";\r\n}\r\n\r\n.icon-message:before {\r\n  content: \"\\e610\";\r\n}\r\n\r\n.icon-close-outlined:before {\r\n  content: \"\\e6e8\";\r\n}\r\n\r\n.icon-check-outlined:before {\r\n  content: \"\\e645\";\r\n}\r\n\r\n.icon-sync:before {\r\n  content: \"\\e786\";\r\n}\r\n\r\n.icon-minus-circle:before {\r\n  content: \"\\e64b\";\r\n}\r\n\r\n.icon-close-circle:before {\r\n  content: \"\\e653\";\r\n}\r\n\r\n.icon-check:before {\r\n  content: \"\\e600\";\r\n}\r\n\r\n.icon-checked:before {\r\n  content: \"\\e646\";\r\n}\r\n\r\n.icon-search:before {\r\n  content: \"\\e699\";\r\n}\r\n\r\n.icon-download:before {\r\n  content: \"\\e60b\";\r\n}\r\n\r\n.icon-plus:before {\r\n  content: \"\\e67b\";\r\n}\r\n\r\n.icon-edit-fill:before {\r\n  content: \"\\e86d\";\r\n}\r\n\r\n.icon-edit:before {\r\n  content: \"\\e60e\";\r\n}\r\n\r\n.icon-close:before {\r\n  content: \"\\e747\";\r\n}\r\n\r\n.icon-picture:before {\r\n  content: \"\\e743\";\r\n}\r\n\r\n.icon-folder-outlined:before {\r\n  content: \"\\e89e\";\r\n}\r\n\r\n.icon-video-fill:before {\r\n  content: \"\\e865\";\r\n}\r\n\r\n.icon-flag:before {\r\n  content: \"\\e72f\";\r\n}\r\n\r\n.icon-set:before {\r\n  content: \"\\eb8d\";\r\n}\r\n\r\n.icon-logout:before {\r\n  content: \"\\e6bc\";\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
